export interface INewbuildingsCompareCell {
  id: string;
  value: string;
}

export interface INewbuildingsCompareRow {
  criterion: string;
  id: string;
  cells: INewbuildingsCompareCell[];
}

export interface INewbuildingsCompareData {
  headers: string[];
  rows: INewbuildingsCompareRow[];
}

const HEADERS = ['', 'ЖК Северный парк', 'ЖК Речной', 'ЖК Солнечный', 'ЖК Центральный', 'ЖК Зеленый квартал'];

const CRITERIA = [
  'Срок сдачи',
  'Класс жилья',
  'Количество корпусов',
  'Тип дома',
  'Отделка',
  'Паркинг',
  'Метро',
  'Двор без машин',
  'Школа рядом',
  'Детский сад',
  'Площадь квартир',
  'Высота потолков',
  'Этажность',
  'Кладовые',
  'Ипотека',
  'Рассрочка',
  'Застройщик',
  'Материал фасада',
  'Охрана',
  'Видеонаблюдение',
];

const VALUES = [
  'Готово',
  '2026 год',
  'Комфорт',
  'Бизнес',
  '12 корпусов',
  'Паркинг',
  'Монолит',
  'Отделка',
  'Метро 10 мин',
  'Двор без машин',
];

export function createMockNewbuildingsCompareData(): INewbuildingsCompareData {
  return {
    headers: HEADERS,
    rows: CRITERIA.map((criterion, rowIndex) => ({
      criterion,
      id: `row-${rowIndex}`,
      cells: Array.from({ length: HEADERS.length - 1 }, (_, columnIndex) => ({
        id: `cell-${rowIndex}-${columnIndex}`,
        value: VALUES[(rowIndex + columnIndex) % VALUES.length],
      })),
    })),
  };
}

export function createMockNewbuildingsCompareRows(): INewbuildingsCompareRow[] {
  return createMockNewbuildingsCompareData().rows;
}
